import { render } from "./The_root_causes_of_the_problemById.vue?vue&type=template&id=f0b029f4&scoped=true"
import script from "./The_root_causes_of_the_problemById.vue?vue&type=script&lang=js"
export * from "./The_root_causes_of_the_problemById.vue?vue&type=script&lang=js"

import "./The_root_causes_of_the_problemById.vue?vue&type=style&index=0&id=f0b029f4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0b029f4"]])

export default __exports__